const HeaderView = () => {
  return (
    <header className="header" id="header">
      <h1 className="heading-1">Hello!</h1>
      <h2 className="heading-2">
        <span>I'm</span> Dominic DeCicco
      </h2>
      <h3 className="heading-3">Web Developer</h3>
    </header>
  );
};

export default HeaderView;
